module.exports = __webpack_public_path__ + "ade037d1d65e587d71705918d907833b.svg";